import React from "react";
import { Modal, StatusPill, formatDate } from "./UI";
import { detectCarrier, getTrackingURL } from "../lib/carrier";

export default function PackageDetailModal({ pkg, onClose, isAdmin }) {
  const carrier     = pkg.shipmentTracking ? detectCarrier(pkg.shipmentTracking) : null;
  const trackingURL = carrier ? getTrackingURL(pkg.shipmentTracking, carrier.code) : null;

  return (
    <Modal title="Package details" onClose={onClose}>
      <div className="detail-photo">
        {pkg.photoURL
          ? <img src={pkg.photoURL} alt="Package" />
          : <div className="detail-photo-placeholder">📦</div>}
      </div>
      <table className="detail-table">
        <tbody>
          <tr><td>Tracking ID</td><td className="mono">{pkg.id}</td></tr>
          <tr><td>Status</td><td><StatusPill status={pkg.status} /></td></tr>

          {pkg.shipmentTracking && (
            <tr>
              <td>Shipment tracking</td>
              <td>
                <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                  <span className="mono" style={{ color: "var(--amber-dark)" }}>{pkg.shipmentTracking}</span>
                  {carrier && (
                    <span className="carrier-badge" style={{ background: carrier.bg, color: carrier.color, padding: "2px 8px", fontSize: 11, margin: 0 }}>
                      {carrier.name}
                    </span>
                  )}
                  {trackingURL && (
                    <a href={trackingURL} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: carrier?.color, fontWeight: 600, textDecoration: "none" }}>
                      Track ↗
                    </a>
                  )}
                </div>
              </td>
            </tr>
          )}

          {isAdmin && <tr><td>Customer</td><td>{pkg.customerName}</td></tr>}
          {isAdmin && <tr><td>Customer email</td><td>{pkg.customerEmail}</td></tr>}
          <tr><td>Description</td><td>{pkg.description || "—"}</td></tr>
          <tr><td>Weight</td><td>{pkg.weight} lbs</td></tr>
          <tr><td>Dimensions</td><td>{pkg.dimensions || "—"}</td></tr>
          <tr><td>Est. delivery</td><td>{formatDate(pkg.eta)}</td></tr>
          {pkg.notes && <tr><td>Warehouse notes</td><td>{pkg.notes}</td></tr>}
          {pkg.itemName
            ? <tr><td>Item name</td><td><strong>{pkg.itemName}</strong></td></tr>
            : <tr><td>Item details</td><td style={{ color: "#92400E", fontWeight: 600 }}>⚠ Not entered yet</td></tr>}
          {pkg.itemValue && <tr><td>Item value</td><td><strong>${pkg.itemValue}</strong></td></tr>}
          {pkg.invoiceURL && (
            <tr>
              <td>Invoice</td>
              <td><a href={pkg.invoiceURL} target="_blank" rel="noreferrer" style={{ color: "var(--blue)", fontWeight: 600 }}>View invoice ↗</a></td>
            </tr>
          )}
          <tr><td>Received on</td><td>{formatDate(pkg.createdAt)}</td></tr>
        </tbody>
      </table>
    </Modal>
  );
}